module.exports = __webpack_public_path__ + "static/media/energetic_sad.910c10b8.svg";